import { FormItem } from '@framework/form';
import * as React from 'react';
import { useTreeReferencesContext } from '../../../../../../tree/references/TreeReferencesContext';
import { ExpressionReferenceInput } from '../../../../../expressions/references/input/ExpressionReferenceInput';
import { WidgetType } from '../../../../Widget';

export interface IConfirmationConfigInputProps {
  name: string;
}

/**
 * Campo di input per collegare un Widget ad un altro, di tipo conferma:
 * In questo caso il sistema richiede di selezionare un widget di tipo
 * `Confirm` che sarà utilizzato per confermare il valore del widget
 */
export function ConfirmationConfigInput(props: IConfirmationConfigInputProps) {
  const { references } = useTreeReferencesContext();
  return (
    <FormItem
      name={props.name}
      label="Conferma del valore"
      help="Richiede che questo campo sia confermato da un Widget di tipo 'Conferma'"
      style={{ marginBottom: 48 }}
    >
      <ExpressionReferenceInput
        width="100%"
        size="large"
        name={props.name}
        placeholder="Seleziona un widget di Conferma"
        references={references}
        config={{ filter: r => r.widgetType === WidgetType.Confirm }}
      />
    </FormItem>
  );
}
